module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABLAgMAAAD7dsokAAAACVBMVEUAnmD80RY6dcR21W9yAAAAH0lEQVR4AWNhwAXoKjMqMyoTOhoGozKjKXFUZlQGBgAUowHXPv21gQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ga.png
// module id = Zee2
// module chunks = 0